import { useToast } from 'vuestic-ui'

const { init } = useToast()

export const toastMessage = (isSuccess: boolean, message: string, color?: string) => {
  if (message.length <= 0) return

  if (isSuccess) {
    init({ message: message, color: color ? color : 'success' })
  } else {
    init({ message: message, color: color ? color : 'danger' })
  }
}
